



































import UserPermissionsComponent from "@/app/components/modals/userPermissions/userPermissions.component.vue";
import ModalAddSpaceComponent from "@/app/components/manageSpace/components/superSpace/modalAddSpace.component.vue";
import SpaceCardComponent from "@/app/admin/components/space/spaceCard.component.vue";

import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "settings-super-space-component",
  components: {
    UserPermissionsComponent,
    ModalAddSpaceComponent,
    SpaceCardComponent,
  },
})
export default class SettingsSuperSpaceComponent extends Vue {
  currentPage = 1;
  itemsPerPage = 30;
  lastPage = 1;
  loader = false;
  openModal = false;
  mounted(): void {
    this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
  }
  get spaceAvailable(): any {
    return this.$store.getters["SpaceStore/getSpacesAvailable"];
  }
  get disabledLoader(): boolean {
    const lastPage = this.$store.getters["SpaceStore/getLastPageSpaces"];
    const page = this.$store.getters["SpaceStore/getSpacesAvailablePage"];
    return page > lastPage;
  }
  get superSpace(): any {
    return this.$store.getters["SuperSpaceStore/getSuperSpace"];
  }
  reload() {
    this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    this.getSpaces();
  }
  async getSpaces(): Promise<void> {
    this.loader = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: space ? space.superSpace.id : this.superSpace.id,
      callback: (response) => {
        this.loader = false;
      },
      callbackError: (error) => {
        this.loader = false;
      },
    });
  }
}
